import * as types from '../actions/action-types';
import _ from 'lodash';

const defaults = {
  loading: false,
  stateKey: 'sf',
  countyKey: 'cf',
  countyNameKey: 'cn',
  stateNameKey: 'sn',

  years: [2015, 2014, 2013, 2012, 2011, 2010, 2009, 2008, 2007],
  year: 2015,

  page: "national"
};

/**
 * Update store based on new selected x/y dimension
 *
 * @param store
 * @param dimension
 * @param fieldName
 */
function setDimension(store, dimension, fieldName) {
  const match = _.find(store.fields, ['field', fieldName]);
  const field = dimension === 'x' ?
    {xField: match.field, xLabel: match.label, xDesc: match.desc} :
    {yField: match.field, yLabel: match.label, yDesc: match.desc};

  return {
    ...store,
    ...field
  };
}

function setYear(store, year) {
  return {
    ...store,
    year
  };
}

function setPage(store, page) {
  return {
    ...store,
    page
  };
}

function setData(store, fields) {
  store = {...store, fields};
  return store;
}

export default (store = defaults, action) => {
  switch (action.type) {
    case types.DIMENSION_DATA_RECEIVED:
      return setData(store, action.data);
    case types.SELECT_FIELD:
      return setDimension(store, action.dimension, action.field);
    case types.SELECT_YEAR:
      return setYear(store, action.year);
    case types.SELECT_PAGE:
      return setPage(store, action.page);
    case types.PAGE_TRANSITION_START:
      return {...store, loading:true};
    case types.PAGE_TRANSITION_END:
      return {...store, loading:false};
    default:
      return store;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/dimensions-reducer.js